import api from "@/lib/api";

// Detect the backend "Owner approval required" signal (409 APPROVAL_REQUIRED).
export const isApprovalRequired = (err) =>
  err?.response?.status === 409 && err.response?.data?.detail?.code === "APPROVAL_REQUIRED";

export const approvalInfo = (err) => err?.response?.data?.detail || {};

// Submit the maker's proposed change to the existing approval engine.
export const submitForApproval = (action, targetId, proposed, reason = "") =>
  api.post("/approvals", { action, target_id: targetId, payload: { proposed }, reason });
